import {CalendarEventResponse} from "@/types/service-response";
import i18n from "@/i18n";

export default class CalendarEventClass {
    private constructor(
        readonly name: string
    ) {
    }

    public static createFromResponse(responseData: CalendarEventResponse[]): CalendarEventClass[] {
        return responseData.map((data: CalendarEventResponse): CalendarEventClass => {
            return new CalendarEventClass(
                i18n.t(`calendarEventDialog.${data.name}`) as string
            )
        })
    }
}